import axios from 'axios'
import { baseUrl } from '@/constants/api.ts'

const urlPrefix = `${baseUrl}help-block/`

export const getHelpBlock = async (params: { url: string }): Promise<any> => axios.get(urlPrefix, { params })
